module.exports = "<input\r\n  #addressInput\r\n  type=\"text\"\r\n  class=\"form-control places-address-input\"\r\n  [attr.placeholder]=\"placeholder\"\r\n  (input)=\"onInput()\"\r\n  (focus)=\"onAddressFocus()\"\r\n  (blur)=\"onAddressBlur()\"\r\n  autocomplete=\"off\">\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/places-address-input/places-address-input.component.html
// module id = ./src/app/shared/places-address-input/places-address-input.component.html
// module chunks = main